import { TrackingMethods } from 'lib/analytics'

// Only used in testing environments
type DummyTracker = {
  trackEvent: () => void
  getTrackingData: () => Record<string, never>
}

export type Tracker = TrackingMethods | DummyTracker
